class MadeToOrderTrigger extends window.BAO.DrawerTrigger {
  connectedCallback () {
    super.connectedCallback()

    window.BAO.MadeToOrder.attach(this)
  }

  updateSelectedDisplay () {
    if (this.productGroup.currentSelectedOptionCount === 1) {
      const selectedOption = this.productGroup.selectedOptions[0].option

      this.els.selected.element.innerHTML = selectedOption.getDisplayText()

      this.updateImage(this.image, selectedOption.getImages().main)

      return
    }

    const selectedOptionToUse =
      this.productGroup.selectedOptions[
        this.productGroup.selectedOptions.length - 1
      ].option

    const selectedAmount = this.productGroup.selectedOptions
      .map(
        (selectedOption) =>
          selectedOption.option.getPriceDatasetAmount() *
          selectedOption.quantity,
      )
      .reduce(
        (amount, selectedOptionAmount) => amount + selectedOptionAmount,
        0,
      )
    this.els.selected.element.textContent = `${this.numberToWord(this.productGroup.currentSelectedOptionCount)} selected${selectedAmount > 0 ? ` (+${window.BAO.Utils.formatMoney(selectedAmount)})` : ''}`

    this.updateImage(this.image, selectedOptionToUse.getImages().main)
  }
}

if (!customElements.get('made-to-order-trigger')) {
  customElements.define('made-to-order-trigger', MadeToOrderTrigger)
}
